/* Snackspot v2 — cart page behaviour. Every cart write goes through window.ssCart (ss-v2.js is the only
   code that talks to /cart/*); this file only re-renders the section afterwards through Shopify's
   Section Rendering API and wires the busy states (CLAUDE.md rule 16). Listeners are delegated on
   document once, so they survive the innerHTML swap. */
(function () {
  'use strict';
  if (window.__ssCartPage) return;
  window.__ssCartPage = true;

  function rootOf(el) { return el && el.closest ? el.closest('[data-ss-cart]') : null; }

  function rerender(root) {
    var sid = root.dataset.sectionId;
    var wrap = document.getElementById('shopify-section-' + sid) || root.parentNode;
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sid), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('Could not refresh the cart'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('shopify-section-' + sid);
        wrap.innerHTML = fresh ? fresh.innerHTML : html;
        return wrap;
      });
  }

  function restoreFocus(wrap, focus) {
    if (!focus) return;
    var el = wrap.querySelector('[data-act="' + focus.act + '"][data-key="' + focus.key + '"]') || wrap.querySelector(focus.fallback || '[data-act="promo"]');
    if (el) el.focus();
  }

  // busy → write → re-render → re-announce (cart-scout re-reads [data-cart-footer]) → restore on both paths
  function run(root, busyEl, label, work, focus) {
    var release = window.ssBusy ? window.ssBusy(busyEl, label) : function () {};
    if (window.ssBusy && !release) return;               // already busy — second press is not a second write
    var cartAfter = null;
    work()
      .then(function (cart) { cartAfter = cart; return rerender(root); })
      .then(function (wrap) { release(); if (cartAfter && window.ssCart) window.ssCart.announce(cartAfter); restoreFocus(wrap, focus); if (focus && focus.after) focus.after(wrap, cartAfter); })
      .catch(function (err) { release(); if (window.ssToast) window.ssToast((err && err.message) || 'Could not update — try again'); });
  }

  function applyPromo(root, btn) {
    var input = root.querySelector('[data-promo-input]');
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    var okText = btn.dataset.promoOk || '', failText = btn.dataset.promoFail || '';
    run(root, btn, btn.dataset.ssBusy || 'Applying…', function () { return window.ssCart.update({ discount: code }); }, { act: 'promo', key: '', fallback: '[data-promo-input]',
      // the re-rendered section has an empty message line; the answer's discount_codes says whether the code took
      after: function (wrap, cart) {
        var msg = wrap.querySelector('[data-promo-msg]'); if (!msg) return;
        var codes = (cart && cart.discount_codes) || [], hit = null;
        for (var i = 0; i < codes.length; i++) if (String(codes[i].code || '').toUpperCase() === code.toUpperCase()) hit = codes[i];
        var ok = !!(hit && hit.applicable);
        msg.textContent = ok ? okText.replace('{code}', hit.code) : failText;
        msg.classList.toggle('is-err', !ok);
      } });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var root = rootOf(t);
    if (!root) return;

    // upsell card: the whole card is clickable as designed; the write lives on its + button
    var card = t.closest('.upsell2-item');
    if (card && !t.closest('[data-act="add"]')) { var plus = card.querySelector('[data-act="add"]'); if (plus) plus.click(); return; }

    var btn = t.closest('[data-act]');
    if (!btn) return;
    var act = btn.dataset.act;
    e.preventDefault();

    if (act === 'promo') { applyPromo(root, btn); return; }

    if (act === 'add') {
      var id = parseInt(btn.dataset.id, 10);
      var name = btn.dataset.name || '';
      run(root, btn, btn.dataset.ssBusy || 'Adding…', function () { return window.ssCart.add([{ id: id, quantity: 1 }], { toast: 'Added: ' + name + ' ✓' }); }, null);
      return;
    }

    var key = btn.dataset.key;
    var line = btn.closest('[data-busyrow]');
    var input = line && line.querySelector('input.qty');
    var cur = input ? (parseInt(input.value, 10) || 0) : 0;
    var qty;
    if (act === 'minus') qty = Math.max(0, cur - 1);
    else if (act === 'plus') qty = cur + 1;
    else if (act === 'remove') qty = 0;
    else return;
    run(root, btn, act === 'remove' ? 'Removing…' : 'Updating…', function () { return window.ssCart.change(key, qty); }, { act: act, key: key, fallback: '[data-act="plus"]' });
  });

  // typed quantity: the + button carries the busy label, the row dims
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.classList.contains('qty')) return;
    var root = rootOf(input);
    if (!root) return;
    var line = input.closest('[data-busyrow]');
    var busyEl = (line && line.querySelector('[data-act="plus"]')) || input;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    run(root, busyEl, 'Updating…', function () { return window.ssCart.change(input.dataset.key, qty); }, { act: 'plus', key: input.dataset.key });
  });

  // Enter in a quantity field updates that line — it must never submit the cart form, whose
  // submit button is Checkout
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !(e.target instanceof HTMLInputElement) || !e.target.classList.contains('qty')) return;
    e.preventDefault();
    e.target.blur();                       // blur fires `change`, which is where the update lives
  });

  // Enter in the promo field applies the code instead of submitting the cart form
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !(e.target instanceof HTMLInputElement) || !e.target.hasAttribute('data-promo-input')) return;
    var root = rootOf(e.target);
    if (!root) return;
    e.preventDefault();
    var btn = root.querySelector('[data-act="promo"]');
    if (btn) applyPromo(root, btn);
  });
})();
